<div class="title-section-container flex flex-col">
    <div class="header-section flex flex-col lg:flex-row justify-between items-center">
        <div class="flex flex-row items-center justify-between w-full">
            <h1 class="title">{{ title() }}</h1>
            <div class="flex gap-x-4">
                <!-- Burger Menu -->
                <div class="icon burger-menu flex justify-center items-center sm:hidden"
                    (click)="isMenuDisplayed.set(!isMenuDisplayed())">
                    <app-icon-svg 
                    (mouseenter)="isMenuHovered.set(true)" 
                    (mouseleave)="isMenuHovered.set(false)"
                    width="32" 
                    height="32" 
                    iconName="menu"
                    [color]="isMenuHovered() ? '#ffce34': '#242651'">
                    </app-icon-svg>
                    @if (isMenuDisplayed()) {
                    <app-burger-menu></app-burger-menu>
                    }
                </div>
            </div>
        </div>
    </div>
</div>